import { createStore, combineReducers, applyMiddleware, compose, Middleware } from 'redux'
import { createEpicMiddleware, Epic } from 'redux-observable'
import { ReplaySubject } from 'rxjs/ReplaySubject'
import { merge } from 'lodash'
import { Store } from 'react-redux'

let store: Store<any>
let injectedReducers: IHashtable<any>
let injectedEpics: IHashtable<Epic<any, any>>

const epic$ = new ReplaySubject<any>(1024)

function combineReducersRecursion(reducers: any): any {
  // If this is a leaf or already combined.
  if (typeof reducers === 'function') {
    return reducers
  }

  // If this is a of reducers and name, combine reducers.
  if (typeof reducers === 'object') {
    let combinedReducers = {}
    for (const key of Object.keys(reducers)) {
      combinedReducers[key] = combineReducersRecursion(reducers[key])
    }
    return combineReducers(combinedReducers)
  }

  // If we get here we have an invalid item in the reducer path.
  throw new Error('Invalid items in list of reducers. Please check it again!')
}

export function createInjectableStore(initialReducers: any, 
                                      initialState: any, 
                                      middlewares: Middleware[]) {
  const rootEpic: Epic<any, any> = (action$: any, state: any) => epic$.mergeMap(epic => epic(action$, state))
  
  const epicMiddleware = createEpicMiddleware(rootEpic)

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  store = createStore(
    combineReducersRecursion(initialReducers),
    initialState,
    composeEnhancers(applyMiddleware(epicMiddleware, ...middlewares))
  )

  injectedReducers = initialReducers
  injectedEpics = { rootEpic }
  
  return store
}

export function injectReducers(reducers: object) {
  if (!reducers) {
    return
  }

  for (const key of Object.keys(reducers)) {
    if (!injectedReducers[key]) {
      injectedReducers[key] = reducers[key]
    } else { // already set, merge it
      const existingReducers = injectedReducers[key]
      const newReducers = reducers[key]
      injectedReducers[key] = merge(existingReducers, newReducers)
    }
  }

  store.replaceReducer(combineReducersRecursion(injectedReducers))
}

export function injectEpics(epics: IHashtable<Epic<any, any>>) {
  if (!epics) {
    return
  }

  if (typeof epics !== 'object') {
    throw new Error('injectEpics error: A map of epics and names are required')
  }

  for (const key of Object.keys(epics)) {
    if (injectedEpics[key]) {
      console.warn(`The epic ${key} was already added`)
      continue
    }
    
    const epic = epics[key]
    injectedEpics[key] = epic
    epic$.next(epic)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/InjectableStore.ts